import { Component, OnInit, Input } from '@angular/core';
import { FormatService } from '@core/services/format/format.service';
import { Goal } from '@core/models/goal.model';
import { ApiService } from '@core/services/api/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.scss'],
})
export class GoalsComponent implements OnInit {
  @Input() goalsData: [];
  public goals: Array<Goal> = [];
  private subs = null;

  constructor(
    public formatter: FormatService,
    public api: ApiService,
    public router: Router) { }

  ngOnInit() {
    this.subs = this.api.get('goals').subscribe(data => {
      this.goals = data.data;
      console.log(data.data);
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  public goToGoalsPage() {
    this.router.navigateByUrl('//dashboard/goals');
  }

}
